export default __webpack_public_path__ + "static/media/800px-CCMSgt.4b863113.jpg";